import { render, staticRenderFns } from "./ComparisonPerRound.vue?vue&type=template&id=8518d8d8&"
import script from "./ComparisonPerRound.vue?vue&type=script&lang=js&"
export * from "./ComparisonPerRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports